import React, { useState } from "react";
import { Box, Container, Typography, Button, Dialog, DialogContent } from "@mui/material";
import { coachexp } from "../../../../assets";
import CoachingPopup from "./CoachingPopup";
import { Fade, Zoom } from "@mui/material";
import { contactForm } from '../../../../api/services';
import { useForm, Controller } from 'react-hook-form';


const ExperienceSection: React.FC = () => {
    const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Box
      sx={{
        py: 10,
        backgroundColor: "#f4f8fc",
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 2, md: 10 } }}>
        <Box
          sx={{
            position: "relative",
            borderRadius: "24px",
            overflow: "hidden",
            minHeight: { xs: 'auto', md: "420px" },
            display: "flex",
            alignItems: "center",
            px: { xs: 2, md: 4 },
            py: { xs: 6, md: 0 },

            // Background Image + Luxury Blue Overlay
            backgroundImage: `
              linear-gradient(
                90deg,
                rgba(15,99,165,0.85) 0%,
                rgba(15,99,165,0.75) 40%,
                rgba(15,99,165,0.55) 70%,
                rgba(15,99,165,0.35) 100%
              ),
              url(${coachexp})
            `,
            //  backgroundImage: `
            // linear-gradient(90deg, rgba(15, 99, 165, 0.85) 0%, rgba(15, 99, 165, 0.75) 40%, rgb(168 188 203 / 55%) 70%, rgb(195 195 195 / 35%) 100%),
            //   url(${coachexp})
            // `,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Content */}
          <Box maxWidth="600px" color="white">
            <Typography
              variant="h1"
              fontWeight={700}
              gutterBottom
              sx={{
                fontSize: { xs: "32px", md: "48px" },
                color: "white",
                textAlign: "start",

                /* Dark stroke for contrast */
                WebkitTextStroke: "1px rgba(0,0,0,0.8)",

                /* Extra shadow for better visibility */
                textShadow: `
                  0 2px 6px rgba(0,0,0,0.8)
                `,
              }}
            >
              Experience Global Excellence Locally in Hyderabad
            </Typography>


            <Typography
              variant="body1"
              sx={{
                opacity: 0.9,
                mb: 4,
                lineHeight: 1.8,
                color: 'white',
                textAlign: 'start'
              }}
            >
              {/* Join ambitious professionals elevating their sales conversations with structured mastery. */}
              Upskilling your workforce and preventing cash flow issues will accelerate your growth            </Typography>

            <Button
              variant="contained"
              onClick={handleOpen} 
              sx={{
                backgroundColor: "white",
                color: "#0f63a5",
                px: 4,
                py: 1.5,
                fontWeight: 600,
                borderRadius: "10px",
                boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                textAlign: 'start',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                "&:hover": {
                  backgroundColor: "#eaf3fb",
                },
                width:{xs:'100%',md:"auto"},
              }}
            >
              Schedule Your Free Consultation
            </Button>
          </Box>
        </Box>
      </Container>
       <Dialog
  open={open}
  onClose={handleClose}
  fullWidth
  TransitionComponent={Zoom}   // 🔥 Smooth scale
  transitionDuration={400}
  BackdropProps={{
    sx: {
      backdropFilter: "blur(8px)",   // 🔥 Backdrop blur
      backgroundColor: "rgba(0,0,0,0.6)",
    },
  }}
  PaperProps={{
    sx: {
      position: "relative",
      borderRadius: "32px",
      background: "linear-gradient(145deg, #0b0f1a, #101826)",
      boxShadow: "0 50px 140px rgba(0,0,0,0.7)",
      overflow: "hidden",
      maxWidth: { xs: "95%", md: "50%" },

      // 🔥 Gold border shimmer
      border: "1px solid rgba(20, 149, 209, 0.6)",

      "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(120deg, transparent, rgba(212,175,55,0.15), transparent)",
        animation: "shimmer 3s infinite",
      },

      "@keyframes shimmer": {
        "0%": { transform: "translateX(-100%)" },
        "100%": { transform: "translateX(100%)" },
      },
    },
  }}
>
        <DialogContent sx={{ p: 0 }}>
          <CoachingPopup handleClose={handleClose} />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ExperienceSection;
